import React, { FC, useCallback, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolBottomSheet from '../NolBottomSheet';
import { GlobalStoreCtx } from '@/stores/GlobalStore';

const CIBottomSheet: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const globalStore = useContext(GlobalStoreCtx);
  const onClick = useCallback(() => {
    store.openCIPopup();
    if (!store.certWindow && !globalStore.AppDevice) {
      store.isPopupBlockModalOpen = true;
    }
  }, []);

  return (
    <NolBottomSheet
      isOpen={store.isCIBottomSheetOpen}
      onRequestClose={() => (store.isCIBottomSheetOpen = false)}
      title={'본인 인증'}
      body={{
        description:
          'NOL 카드 가입 및 카드 가입여부 등을 확인하기 위하여 본인 인증이 필요합니다. 아래 본인 인증하기 버튼을 눌러 인증 화면으로 이동해주세요.',
      }}
      button={{ label: '본인 인증하기', onClick }}
    />
  );
};

export default observer(CIBottomSheet);
